import { getRoot, Instance, types } from 'mobx-state-tree';
import { PageModel, PageRoutes, RootType } from '../../../internal';
import { QuizAnswerApiItem } from '../../../utils/api/QuizApi';

export const OdgovorDetaljiModel = types
  .compose(
    PageModel,
    types.model({
      answerText: types.optional(types.string, ''),
      isCorrect: types.optional(types.boolean, false),
      orderNumber: types.optional(types.number, 0),
    })
  )
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
  }))
  .actions((self) => ({
    setAnswerText(value: string) {
      self.answerText = value;
    },
    setIsCorrect(value: boolean) {
      self.isCorrect = value;
    },
    setOrderNumber(value: number) {
      self.orderNumber = value;
    },
    setFromApi(data: {
      answerText: string;
      isCorrect: boolean;
      orderNumber: number;
    }) {
      self.answerText = data.answerText;
      self.isCorrect = data.isCorrect;
      self.orderNumber = data.orderNumber;
    },
    navigateBack() {
      const { quizId, questionId } = self.root.router.queryParams;
      self.root.router.navigate({
        newView: PageRoutes.Odgovori.id,
        queryParams: { quizId, questionId },
      });
    },
    async beforePageEnter() {
      const { quizId, questionId, id } = self.root.router.queryParams;
      const answer = await self.root.api.quiz.getAnswer(
        Number(quizId),
        Number(questionId),
        Number(id)
      );
      this.setFromApi(answer);
    },
    async submit() {
      const { quizId, questionId, id } = self.root.router.queryParams;
      try {
        if (self.isCorrect) {
          const existing = await self.root.api.quiz.getAnswers(
            Number(quizId),
            Number(questionId)
          );
          await Promise.all(
            existing
              .filter(
                (a: QuizAnswerApiItem) => a.isCorrect && a.id !== Number(id)
              )
              .map((a: QuizAnswerApiItem) =>
                self.root.api.quiz.updateAnswer(
                  Number(quizId),
                  Number(questionId),
                  a.id,
                  { isCorrect: false }
                )
              )
          );
        }
        await self.root.api.quiz.updateAnswer(
          Number(quizId),
          Number(questionId),
          Number(id),
          {
            answerText: self.answerText,
            isCorrect: self.isCorrect,
            orderNumber: self.orderNumber,
          }
        );
        this.navigateBack();
      } catch (err: any) {
        const message =
          err?.response?.data?.message ??
          'Došlo je do greške pri čuvanju odgovora.';
        self.root.showFailure(message, null);
      }
    },
  }))
  .named('OdgovorDetaljiModel');

export type OdgovorDetaljiModelType = Instance<typeof OdgovorDetaljiModel>;
